/* ============
 * English Language File
 * ============
 */
import shared from "./shared.json";
import admin from "./admin.json";
import app from "./app.json";
import erp from "./erp.json";
import marketing from "./marketing.json";
import account from "./account.json";
import settings from "./settings.json";
import models from "./models.json";

export default {
  shared,
  admin,
  app,
  erp,
  marketing,
  account,
  settings,
  models
};